export default __webpack_public_path__ + "static/media/34.af1033d5.png";